.container {
  display: flex;
  flex-direction: column;
  font-family: var(--cxy-font-family-sans);
  color: var(--oc-text-body);
  border-radius: 8px;
}

.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
}

.title {
  font-family: var(--cxy-font-family-sans);
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0;
  color: var(--cxy-color-midnight-blue-600);
}

.sportButton {
  align-items: center;
  background-color: var(--oc-primary-white);
  border: 1px solid var(--cxy-color-midnight-blue-600);
  border-radius: 4px;
  color: var(--cxy-color-midnight-blue-600);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-weight: 600;
  gap: 8px;
  justify-content: space-between;
  padding: 8px;
}

.sportButtonLabel {
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.sportButtonChevron {
  flex-shrink: 0;
  height: 12px;
  transition: transform 0.15s ease;
  width: 12px;
}

.sportButtonChevronOpen {
  transform: rotate(180deg);
}

.sportMenu {
  background: var(--oc-primary-white);
  border: 1px solid var(--cxy-color-grey-200);
  border-radius: 4px;
  box-shadow: 0 0 4px rgba(56, 64, 74, 0.06);
  max-height: 192px;
  min-width: 156px;
  outline: none;
  overflow: hidden auto;
  padding: 0;
  scrollbar-color: var(--cxy-color-grey-300) transparent;
  scrollbar-width: thin;
  z-index: 10;

  &::-webkit-scrollbar {
    width: 11px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--cxy-color-grey-300);
    background-clip: content-box;
    border: 4px solid transparent;
    border-radius: 50px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.sportMenuItem {
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--cxy-color-grey-200);
  color: var(--cxy-color-midnight-blue-600);
  cursor: pointer;
  display: block;
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 8px;
  text-align: left;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &:focus {
    background: var(--mpb-color-row-highlight, #f2f5f6);
    outline: none;
  }
}

.sportMenuItemSelected {
  background: var(--mpb-color-row-highlight, #f2f5f6);
}

.list {
  background: var(--oc-primary-white);
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  border-bottom: 1px solid var(--cxy-color-grey-200);

  &:last-child {
    border-bottom: none;
  }
}

.link {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: auto 1fr auto;
  padding: 8px 0;
}

.linkNoIcon {
  grid-template-columns: 1fr auto;
}

.sportIcon {
  align-items: center;
  color: var(--oc-text-body);
  display: inline-flex;
  font-size: 28px;
  justify-content: center;
}

.betInfo {
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-decoration: none;
}

.betName {
  font-size: 14px;
  font-weight: 600;
  color: var(--cxy-color-midnight-blue-600);
}

.subeventName {
  color: var(--cxy-color-midnight-blue-350);
  font-size: 12px;
}

.oddsButton {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 64px;
  height: 36px;
  border-radius: 3px;
  font-family: var(--cxy-font-family-sans);
  font-size: 15px;
  font-weight: 600;
  background: var(--oc-bg-grey);
  cursor: pointer;

  // Selected (in-betslip) background. Scoped under .oddsButton so it has higher specificity
  // than the base background above — the shared OddsButton's single-class `selectedBet` rule
  // ties with .oddsButton on specificity and loses on source order, so the green never showed.
  &.selected {
    background: var(--ogm-grid-selected-cell-bg-color);
    color: var(--ogm-grid-selected-cell-text-color);
  }
}

.odds {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 64px;
  height: 36px;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 600;
  background: var(--oc-bg-grey);
}
